import React from "react";
import { motion, useScroll, useSpring, useTransform } from "framer-motion";

/**
 * A bold gold progress bar fixed at the very top of the page.
 * Always shows a minimum 2% sliver so the design feature is visible at rest.
 * 6px tall, full opacity, saturated gold (#D4AF37).
 */
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  // Keep a minimum 2% width so the bar is always a visible design cue.
  const clamped = useTransform(scrollYProgress, [0, 1], [0.02, 1]);
  const scaleX = useSpring(clamped, {
    stiffness: 120,
    damping: 24,
    mass: 0.35,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      style={{ scaleX, transformOrigin: "0% 50%" }}
      className="fixed top-0 left-0 right-0 h-[6px] bg-[#D4AF37] z-[10000] opacity-100 pointer-events-none"
      aria-hidden
    />
  );
};

export default ScrollProgress;
